import * as tslib_1 from "tslib";
import { settings } from '../../../settings';
import { CmsActionTypes } from './types';
import CmsResponseMapper from '../../mapper/CmsResponseMapper';
import { websiteActions } from '../../../websiteStateEngine';
var webapiBaseUrl = settings.webApiHost + settings.webApiPrefix;
export function getBlockSettings(protocol, path, searchflow) {
    var _this = this;
    if (searchflow === void 0) { searchflow = true; }
    return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var result;
        return tslib_1.__generator(this, function (_a) {
            if (window.searchBlockConfig != null) {
                result = {
                    type: CmsActionTypes.RECEIVE_BLOCK_SETTINGS,
                    response: CmsResponseMapper.map(window.searchBlockConfig)
                };
                if (searchflow) {
                    dispatch(websiteActions.setActiveTabSearchMask(result.response.settings.activeTabNormalized));
                }
                return [2 /*return*/, dispatch(result)];
            }
            // TODO: Instead of fetch, provide here a default cms block setting
            fetch(protocol + '//' + webapiBaseUrl + path)
                .then(function (res) { return res.json(); })
                .then(function (response) {
                var result = {
                    type: CmsActionTypes.RECEIVE_BLOCK_SETTINGS,
                    response: CmsResponseMapper.map(response)
                };
                return dispatch(result);
            })
                .catch(function (error) {
                console.error(error);
            });
            return [2 /*return*/];
        });
    }); };
}
;
